// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactSitterWidget_root__A1G_1"};